import { render, staticRenderFns } from "./ColorComponent.vue?vue&type=template&id=700ced4c&"
import script from "./ColorComponent.vue?vue&type=script&lang=js&"
export * from "./ColorComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports